import routeMixin from '@/router/routeMixin'
import globalMixin from '../globalMixin'
import mixins from 'vue-typed-mixins'
import { InventaireEffectueLightOutput } from './models/InventaireEffectueLightOutput'
import { InventaireEffectueOutput } from './models/InventaireEffectueOutput'
import Openable from '@/global/viewmodels/openable'
import { HubConnectionBuilder } from '@microsoft/signalr'
import { ProduitLightOutput } from '@/domain/ProduitLightOutput'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import { Files, ResponseType } from '@/global/requesting/requester'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    data: function() {
        return {
            resultats: [] as InventaireEffectueLightOutput[],
            inventaire: null as null | InventaireEffectueOutput,
            openableInventaireInfo: new Openable(),
            openableArchivage: new Openable(),
            dateArchivage: '',
            search: '',
            observationInitial: null as string | null,
            afficherAnciens: false,
            afficherLesDepots: false,
            afficherArchives: false,
            openableInventaireProduit: new Openable(),
            openableModificationResponsableGestionnaire: new Openable(),
            inventaireProduitTemp: null as null | ProduitLightOutput,
            nomGestionnaireDepotTemp: null as null | string,
            fonctionGestionnaireDepotTemp: null as null | string,
            mailGestionnaireDepotTemp: null as null | string,
            modificationGestionnaire: false,
            modificationResponsable: false,
            businessUnit: 0,
            businessUnits: [
                { value: 0, text: 'Tous' },
                { value: 1, text: 'Dentaire' },
                { value: 2, text: 'Orthopédie' }
            ]
        }
    },
    methods: {
        getResultatInventaires() {
            this.$loader.go()
            this.$http
                .api(`inventaire/resultats?afficherAnciens=${this.afficherAnciens}&afficherLesDepots=${this.afficherLesDepots}&businessUnit=${this.businessUnit}&afficherArchives=${this.afficherArchives}`)
                .get()
                .then(x => {
                    this.resultats = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadInventaire(id: number) {
            this.$http
                .api(`inventaire/resultat?id=${id}`)
                .get()
                .then(x => {
                    this.inventaire = x.data
                    this.observationInitial = x.data.observation
                    this.openableInventaireInfo.open()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        sauvegarderModifications() {
            const that = this
            if (that.inventaire)
                this.$http
                    .api(`inventaire/observation`)
                    .post({ id: that.inventaire.id, observation: that.inventaire?.observation })
                    .then(() => {
                        if (that.inventaire) that.observationInitial = that.inventaire.observation
                        this.$swal.toast.success('Les observations ont bien été sauvegardées.')
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
        },
        downloadFichierLettreInventaire(demande: InventaireEffectueOutput) {
            this.$http
                .api(`inventaire/get-url-lettre-inventaire?input=${demande.id}`)
                .get()
                .then(x => {
                    console.log(x)
                    window.location.href = this.$http.baseUrl + `/inventaire/get-lettre-inventaire?input=${x.data}`
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        downloadFichierInventaireDetaille(demande: InventaireEffectueOutput) {
            this.$http
                .api(`inventaire/get-url-inventaire-detaille?input=${demande.id}`)
                .get()
                .then(x => {
                    window.location.href = this.$http.baseUrl + `/inventaire/get-inventaire-detaille?input=${x.data}`
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        downloadFichierInventaireDetailleExcel(demande: InventaireEffectueOutput) {
            this.$http
                .api(`inventaire/get-url-inventaire-detaille-excel?input=${demande.id}`)
                .get()
                .then(x => {
                    window.location.href = this.$http.baseUrl + `/inventaire/get-inventaire-detaille-excel?input=${x.data}`
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        downloadFichierInventaireAllExcel() {
            this.$http
                .api(`inventaire/get-all-inventaires-excel?afficherDepot=${this.afficherLesDepots}`, false, ResponseType.Blob)
                .get()
                .then(x => {
                    console.log(x)
                    Files.download('Liste des inventaire.xlsx', x.data)
                })
        },
        deleteInventaire() {
            this.$swal.confirm.yesCancel('Suppression', "Etes-vous sûr de vouloir supprimer l'inventaire ?", 'Oui').then(res => {
                if (res.isConfirmed && this.inventaire) {
                    this.$http
                        .api(`inventaire`)
                        .deleteWithData(this.inventaire?.id)
                        .then(x => {
                            this.$swal.toast.success("L'inventaire a bien été supprimé")
                            this.getResultatInventaires()
                            this.openableInventaireInfo.close()
                        })
                        .catch(x => this.$swal.toast.errorApi(x))
                        .finally(() => this.$loader.stop())
                }
            })
        },
        archiveInventaire() {
            this.$swal.confirm.yesCancel('Suppression', 'Etes-vous sûr de vouloir archiver les inventaires ?', 'Oui').then(res => {
                if (res.isConfirmed && this.dateArchivage) {
                    this.$http
                        .api(`inventaire/archive?date=${this.dateArchivage}`)
                        .get()
                        .then(x => {
                            this.$swal.toast.success("Les inventaires ont bien été archivés")
                            this.getResultatInventaires()
                            this.openableArchivage.close()
                        })
                        .catch(x => this.$swal.toast.errorApi(x))
                        .finally(() => this.$loader.stop())
                }
            })
        },
        envoyerMailInventaire(demande: InventaireEffectueOutput) {
            this.$http
                .api(`inventaire/envoyer-mail`)
                .post({ id: demande.id })
                .then(x => {
                    this.$swal.toast.success('Le mail a été envoyé.')
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        selectProduitToChange(item: ProduitLightOutput) {
            this.inventaireProduitTemp = JSON.parse(JSON.stringify(item))
            this.openableInventaireProduit.open()
        },
        annulationProduitToChange() {
            if (this.inventaireProduitTemp == null) return
            this.inventaireProduitTemp = null

            this.openableInventaireProduit.close()
        },
        formatCommentaireProduit(commentaire: string) {
            return commentaire.split('\n').join('<br/>')
        },
        sauvegarderChangementProduit() {
            if (!this.inventaireProduitTemp) return
            if (this.inventaireProduitTemp.ancienStatut == null && this.inventaireProduitTemp.nouveauStatut == null) {
                this.$swal.toast.error('Veuillez saisir un nouveau statut')
                return
            }

            this.$http
                .api(`inventaire/produit`)
                .post(this.inventaireProduitTemp)
                .then(x => {
                    if (!this.inventaire) return

                    this.$swal.toast.success('Le produit a bien été sauvegardé')
                    this.getResultatInventaires()
                    this.loadInventaire(this.inventaire.id)
                    this.inventaireProduitTemp = null
                    this.openableInventaireProduit.close()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        fermerPopUpInventaire() {
            const close = () => {
                this.openableInventaireInfo.close()
                this.inventaire = null
                this.observationInitial = null
            }

            if (this.editObservation) {
                this.$swal.confirm.yesCancel('Sauvegarde', 'Vous avez des modifications sur les observations en attente de sauvegarde. Voulez-vous vraiment quitter sans sauvegarder ?', 'Oui').then(a => (a.isConfirmed ? close() : null))
            } else {
                close()
            }
        },
        modifierInfosGestionnaireDepot() {
            if (!this.inventaire) return

            this.modificationGestionnaire = true
            this.nomGestionnaireDepotTemp = this.inventaire.nomGestionnaireDepot
            this.fonctionGestionnaireDepotTemp = this.inventaire.fonctionGestionnaireDepot
            this.mailGestionnaireDepotTemp = this.inventaire.mailGestionnaireDepot

            this.openableModificationResponsableGestionnaire.open()
        },
        annulationModificationResponsableGestionnaire() {
            this.modificationGestionnaire = false
            this.nomGestionnaireDepotTemp = null
            this.fonctionGestionnaireDepotTemp = null
            this.mailGestionnaireDepotTemp = null
        },
        sendInfoResponsableGestionnaire() {
            this.$http
                .api(`inventaire/modification-responsable-gestionnaire`)
                .post({
                    id: this.inventaire?.id,
                    nomGestionnaireDepot: this.nomGestionnaireDepotTemp,
                    fonctionGestionnaireDepot: this.fonctionGestionnaireDepotTemp,
                    mailGestionnaireDepot: this.mailGestionnaireDepotTemp
                })
                .then(x => {
                    if (!this.inventaire) return

                    this.$swal.toast.success('Les modifications ont été sauvegardées')
                    this.loadInventaire(this.inventaire.id)
                    this.modificationGestionnaire = false
                    this.nomGestionnaireDepotTemp = null
                    this.fonctionGestionnaireDepotTemp = null
                    this.mailGestionnaireDepotTemp = null
                    this.openableModificationResponsableGestionnaire.close()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        setInventaireVide(codeClient: string) {
            this.$http
                .api(`inventaire/set-inventaire-vide?codeClient=${codeClient}`)
                .get()
                .then(x => {
                    this.getResultatInventaires()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {
        editObservation: function(): boolean {
            if (this.observationInitial === null) return false

            if (this.inventaire === null) return false

            return this.observationInitial !== this.inventaire.observation
        }
    },
    mounted() {
        this.getResultatInventaires()

        const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()

        connection.start().then(() => {
            connection.on('RefreshInventairesEffectuees', () => {
                this.getResultatInventaires()
            })
        })
    },
    watch: {
        afficherAnciens: function() {
            this.getResultatInventaires()
        },
        afficherLesDepots: function() {
            this.getResultatInventaires()
        },
        afficherArchives: function() {
            this.getResultatInventaires()
        },
        businessUnit: function() {
            this.getResultatInventaires()
        }
    }
})
